import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-landing-horizontal-crawler',
  standalone: true,
  imports: [],
  templateUrl: './landing-horizontal-crawler.component.html',
  styleUrl: './landing-horizontal-crawler.component.scss'
})
export class LandingHorizontalCrawlerComponent {
  @Input() itemsList: any = [];

}
